// Pure Header-Builder. Lebt in eigener Datei, damit Tests ihn ohne
// Supabase-Browser-Client-Imports nutzen koennen.

export function buildApiHeaders(
  token: string | null,
  actAsUserId: string | null,
  init?: HeadersInit,
): Headers {
  const headers = new Headers(init);
  headers.set("Content-Type", "application/json");
  if (token) headers.set("Authorization", `Bearer ${token}`);
  if (actAsUserId) headers.set("X-Act-As-User-Id", actAsUserId);
  return headers;
}
